import Vue from 'vue';
import { ValidationObserver, ValidationProvider, configure, extend } from 'vee-validate';
import { required, email, required_if, confirmed, min, regex } from 'vee-validate/dist/rules';
import { i18n } from '@/i18n';
import moment from 'moment';

configure({
    // @ts-ignore
    defaultMessage: (field, values) => {
        return i18n.t(`validation.${values!._rule_}`, values);
    },
});

// Add the required rule
extend('required', required);

// Add the email rule
extend('email', email);

// Add the required_if rule
extend('required_if', required_if);

// Add the confirmed rule
extend('confirmed', confirmed);

// Add the min rule
extend('min', min);

// Add the between rule
extend('regex', regex);

// Adding the after or equal rule (for dates)
extend('after', {
    params: ['target'],
    validate(value, { target }: any) {
        return moment(value).isAfter(moment(target));
    },
    message: 'Date is not after',
});

// Adding the after rule (for dates)
extend('after_or_equal', {
    params: ['target'],
    validate(value, { target }: any) {
        return moment(value).isSameOrAfter(moment(target));
    },
    message: 'Date is not same or after',
});

// Adding the before rule (for dates)
extend('before', {
    params: ['target'],
    validate(value, { target }: any) {
        return moment(value).isBefore(moment(target));
    },
    message: 'Date is not before',
});

// Adding the before or equal rule (for dates)
extend('after_or_equal', {
    params: ['target'],
    validate(value, { target }: any) {
        return moment(value).isSameOrBefore(moment(target));
    },
    message: 'Date is not same or before',
});

// Adding the greater than zero rule (for numbers)
extend('greaterThanZero', {
    validate(value) {
        return value > 0;
    },
    message: 'Value must be greater than zero',
});

// Adding the password rule
extend('password', {
    validate(value) {
        return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,}$/.test(value);
    },
    message: 'Password must contain a digit, a lower case letter, an upper case letter, a special character, '
            + 'and must be at least 8 characters long',
});

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
